module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "klickbox-edit-item": "option",
      "klickbox-edit-label": _vm.$t('edit.canvas.answer_options')
    },
    on: {
      "mouseenter": function($event) {
        return _vm.canvasEnableHighlight({
          event: $event
        })
      }
    }
  }, _vm._l((_vm.stepPreview.options), function(option) {
    return _c('div', {
      staticClass: "kbx-form"
    }, [_c('label', {
      class: [_vm.stepPreview.multiple_answers ? 'kbx-checkbox' : 'kbx-radio'],
      style: (_vm.stepStyle('option'))
    }, [_c('input', {
      attrs: {
        "type": [_vm.stepPreview.multiple_answers ? 'checkbox' : 'radio'],
        "name": "example"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(option.label))])])])
  }), 0)])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-9e7b6570!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/preview/step/question/Options.vue
 ** module id = 891
 ** module chunks = 1
 **/